import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetCompanionSubscriptionQuery,
  GetCompanionSubscriptionQueryVariables,
} from "./CompanionSubscription.generated";

const COMPANION_SUBSCRIPTION_QUERY: TypedDocumentNode<
  GetCompanionSubscriptionQuery,
  GetCompanionSubscriptionQueryVariables
> = gql`
  query GetCompanionSubscription {
    user {
      uuid
      account {
        uuid
        isTeamsCustomer
      }
      companionSubscription {
        planKey
        status
        monthlyTreats
        activeUntil
      }
    }
  }
`;

export default COMPANION_SUBSCRIPTION_QUERY;
